import React, { useEffect, useRef, useState } from "react";
import { Media, Image, ButtonGroup, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import locale from "locale";
import { getClientAvatar, getClientLink } from "tools";
import { encodeHtmlChars, replaceEmojiToImage, replaceUrlsToLinks } from "../../../../../platform/src/helpers/html-helpers";
import { getFullname } from "../../../../helpers/getFullname";
import { MESSAGES_TYPES } from "../../../../constant/common";
import { useEventContext } from "../../../../context";
import SendMessageForm from "../SendMessageForm";
import "./style";

function ClientAvatar({ client }) {
    if (!client) {
        client = {};
    }

    return (
        <a href={getClientLink(client)} target="_blank">
            <Image src={getClientAvatar(client)} width="50" rounded />
        </a>
    );
}

function ClientNickname({ message, event }) {
    const { clientRegistration, client } = message || {}
    const _client = clientRegistration || client || {};
    const { nickname } = _client;
    // const nickname = getClientNickname((message?.clientRegistration ?? message?.client), event.moduleAuth.nickname);
    const link = `/event/${event.eventPassword}/client/${message.clientRegistration?.id ?? message.client?.id}`;

    if (event.client.allowPrivateClientDataAccess) {
        return (
            <Link to={link} className="message-client">{nickname}</Link>
        );
    }

    return (
        <>{nickname}</>
    );
}

export default function Message({
        type,
        message,
        children,
        client,
        isLectorMessage,
        onShowLectorModal,
        onSendAnswer,
        onAnswered,
        onChangeFixed,
        onModerate,
        onDelete,
        onClientBan,
        onDeleteClientBan,
        onSwitchTo,
        isHybrid,
        isUserBanned,
        sortMethodType,
        theme,
    }) {
    const { event } = useEventContext();
    const [showAnswerForm, setShowAnswerForm] = useState(false);
    const messageRef = useRef(null);
    const clientRegistration = message?.clientRegistration ?? message?.client;
    const displayRating = type === MESSAGES_TYPES.QUESTION && sortMethodType === 'rating';

    useEffect(() => {
        if (!messageRef.current) return;

        let text = message.text;
        text = encodeHtmlChars(text);
        text = replaceEmojiToImage(text);
        text = replaceUrlsToLinks(text);

        messageRef.current.innerHTML = text;
    }, [message.text])

    const handleSendMessage = (data) => {
        onSendAnswer(Object.assign({parentId: message.id}, data));
        setShowAnswerForm(false);
    };
    
    const handleToggleAnswerForm = () => {
        setShowAnswerForm(!showAnswerForm);
    };

    const handleToggleUserBan = () => {
        isUserBanned ? onDeleteClientBan(clientRegistration) : onClientBan(clientRegistration);
    };

    return (
        <Media className={"comment-message" + (message.fixed ? ' message-fixed' : '')}>
            <Media.Left className={message.moderate ? '' : 'not-moderated'}>
                <ClientAvatar client={clientRegistration} />
            </Media.Left>
            <Media.Body>
                <ButtonGroup bsSize="small" style={{float: 'right'}} className="message-moderate-controls">
                    {!!onShowLectorModal && <Button onClick={() => onShowLectorModal(message)}>{isLectorMessage ? 'Закрыть у ведущего' : 'Показать ведущему'}</Button>}
                    {!!onAnswered && <Button onClick={() => onAnswered(message)}>{message.answered ? 'Отменить ответ' : 'Отметить отвеченным'}</Button>}
                    {!!onChangeFixed && <Button onClick={() => onChangeFixed(message)}>{message.fixed ? 'Открепить' : 'Закрепить'}</Button>}
                    {!!onModerate && <Button onClick={() => onModerate(message)}>{message.moderate ? locale('message.control.hide') : locale('message.control.show')}</Button>}
                    {!!onSwitchTo && <Button onClick={() => onSwitchTo(message)}>{type === 'comment' ? 'В вопросы' : 'В комментарии'}</Button>}
                    {!!onDelete && <Button onClick={() => onDelete(message)}>{locale('message.control.delete')}</Button>}
                    {!!onClientBan &&
                        <Button onClick={handleToggleUserBan}>
                            {locale(isUserBanned ? 'client.unban.button' : 'client.ban.button')}
                        </Button>
                    }
                </ButtonGroup>
                <div className={message.moderate ? '' : 'not-moderated'}>
                    <div>
                        {type === MESSAGES_TYPES.QUESTION && !!theme && (
                            <span style={{ marginRight: '1rem' }}>{theme.titleRu || theme.titleEn}</span>
                        )}
                        <ClientNickname message={message} event={event} />
                        {message.anonymous && <span> [Anonymous]</span>}
                        <span className="message-time">{moment.unix(message.time).format('HH:mm:ss DD-MM-YYYY')}</span>
                        {isHybrid && clientRegistration?.participationType && <span className="message-type">{locale(`message.participationType.${clientRegistration?.participationType}`)}</span>}
                        {displayRating
                            ? <>
                                <span className="message-rating-hint" />
                                {message.likes - message.dislikes}
                                <span className="message-rating-hint dislike" />
                            </>
                            : <>
                                {message.hasOwnProperty('likes') && <span className="message-rating-hint">{message.likes || 0}</span>}
                                {message.hasOwnProperty('dislikes') && <span className="message-rating-hint dislike">{message.dislikes || 0}</span>}
                            </>
                        }
                        {message.fixed && <span className="message-fixed-hint">Закреплено</span> }
                        {message.answered && <span className="message-answered-hint">Отвечено</span>}
                        {isLectorMessage && <span className="message-lectorModal-hint">У ведущего</span>}
                        {client && !!onSendAnswer && <Button bsStyle="link" bsSize="small" onClick={handleToggleAnswerForm}>{locale('message.answer.button')}</Button>}
                    </div>
                    <div>
                        {message.targetMember && <span className="message-targetMember">@{getFullname(message.targetMember)}, </span>}
                        <span ref={messageRef} className="message-text" />
                    </div>
                    {children}
                    {showAnswerForm && <SendMessageForm event={event} client={client} onSubmit={handleSendMessage} />}
                </div>
            </Media.Body>
        </Media>
    )
}
